import React, { useEffect, createElement } from 'react';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import LogoSection from './components/LogoSection';
import StatsSection from './components/StatsSection';
import TeamSection from './components/TeamSection';
import TimelineSection from './components/TimelineSection';
import FAQSection from './components/FAQSection';
import Footer from './components/Footer';
import ThankYouPage from './pages/ThankYouPage';
import HealthcareClinicsPage from './pages/HealthcareClinicsPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsOfServicePage from './pages/TermsOfServicePage';
// Home page component
const HomePage = () => <>
    <HeroSection data-id="element-0" />
    <LogoSection data-id="element-1" />
    <StatsSection data-id="element-2" />
    <TeamSection data-id="element-3" />
    <TimelineSection data-id="element-4" />
    <FAQSection data-id="element-5" />
  </>;
export function App() {
  return <HelmetProvider data-id="element-6">
      <BrowserRouter data-id="element-7">
        <div className="flex flex-col min-h-screen bg-white" data-id="element-8">
          <Helmet data-id="element-9">
            <link rel="preconnect" href="https://fonts.googleapis.com" data-id="element-10" />
            <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" data-id="element-11" />
            <link href="https://fonts.googleapis.com/css2?family=EB+Garamond:ital,wght@0,400..800;1,400..800&family=Libre+Caslon+Text:ital,wght@0,400;0,700;1,400&display=swap" rel="stylesheet" data-id="element-12" />
            <script src="https://fast.wistia.com/player.js" async data-id="element-13"></script>
            <script src="https://fast.wistia.com/embed/ryfwlsyz5l.js" async type="module" data-id="element-14"></script>
            <style data-id="element-15">{`
              @import url("https://fonts.googleapis.com/css2?family=EB+Garamond:ital,wght@0,400..800;1,400..800&family=Libre+Caslon+Text:ital,wght@0,400;0,700;1,400&display=swap");
              h1, h2, h3, h4, h5, h6 {
                font-family: "EB Garamond", serif !important;
                font-optical-sizing: auto !important;
                font-weight: 600 !important;
                font-style: normal !important;
              }
              wistia-player[media-id='ryfwlsyz5l']:not(:defined) { 
                background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/ryfwlsyz5l/swatch'); 
                display: block; 
                filter: blur(5px); 
                padding-top:52.6%; 
              }
            `}</style>
          </Helmet>
          <Routes data-id="element-16">
            <Route path="/" element={<main className="flex-grow" data-id="element-18">
                  <HomePage data-id="element-19" />
                </main>} data-id="element-17" />
            <Route path="/thankyoupage" element={<ThankYouPage data-id="element-21" />} data-id="element-20" />
            <Route path="/healthcareclinics" element={<HealthcareClinicsPage data-id="element-23" />} data-id="element-22" />
            <Route path="/privacypage" element={<PrivacyPage data-id="element-25" />} data-id="element-24" />
            <Route path="/termsofservice" element={<TermsOfServicePage data-id="element-27" />} data-id="element-26" />
          </Routes>
          <Routes data-id="element-28">
            <Route path="/" element={<Footer data-id="element-30" />} data-id="element-29" />
            <Route path="/healthcareclinics" element={<Footer data-id="element-32" />} data-id="element-31" />
          </Routes>
        </div>
      </BrowserRouter>
    </HelmetProvider>;
}